import React, { Component } from "react";
import { connect } from "react-redux";
import { Router, Switch, Route, Link } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

import Login from "./components/login.component";
import Register from "./components/register.component";
import Home from "./components/home.component";
import Profile from "./components/profile.component";
import BoardUser from "./components/board-user.component";
import BoardModerator from "./components/board-moderator.component";
import BoardAdmin from "./components/board-admin.component";

import PageAllDevices from "./Devices/AllDevices/PageAllDevices";
import PageAllDevices_automat from "./Devices/AllDevices/PageAllDevices_automat";
import PageSelectedDevice from "./Devices/SelectedDevice/PageSelectedDevice"
import PageSelectedDevMobile from "./Devices/SelectedDeviceMobile/PageSelectedDevMobile.jsx"
import FrontPage from "./Devices/FrontPage/FrontPage";
import StatPageFrontpage from "./Devices/Stats/FrontPage/PageFrontpage"

import { logout } from "./actions/auth";
import { clearMessage } from "./actions/message";

import { history } from './helpers/history';

// import AuthVerify from "./common/auth-verify";
import EventBus from "./common/EventBus";
import DevNav from "./Devices/DevServices/DevNav"

import PageSensCollection from "./Devices/SensorsCollection/PageSensCollection"
import PagexSensCollection from "./Devices/SensorsCollection/PagexSensCollection"
import PageProjects from "./Projects/PageProjects"
import SelectedProject from "./Projects/SelectedProject/SelectedProject"
import PageSelectedDesk from "./Projects/SelectedDesk/PageSelectedDesk"
import PageSelectedDeskMobile from "./Projects/SelctedDeskMobile/PageSelectedDeskMobile.jsx"
import ServicePage from "./Devices/ServicePage/ServicePage"
import Test from "./Devices/Test/Test"


class App extends Component {
  constructor(props) {
    super(props);
    this.logOut = this.logOut.bind(this);

    this.state = {
      showModeratorBoard: false,
      showAdminBoard: false,
      currentUser: undefined,
    };

    history.listen((location) => {
      props.dispatch(clearMessage()); // clear message when changing location
    });
  }

  componentDidMount() {
    const user = this.props.user;

    if (user) {
      this.setState({
        currentUser: user,
        showModeratorBoard: user.roles.includes("ROLE_MODERATOR"),
        showAdminBoard: user.roles.includes("ROLE_ADMIN"),
      });
    }

    EventBus.on("logout", () => {
      this.logOut();
    });
  }

  componentWillUnmount() {
    EventBus.remove("logout");
  }

  logOut() {
    this.props.dispatch(logout());
    this.setState({
      showModeratorBoard: false,
      showAdminBoard: false,
      currentUser: undefined,
    });
  }

  navNotUserContent = (currentUser = this.state.currentUser) => {
    return (
      <nav className="navbar navbar-expand navbar-dark bg-dark">
      <Link to={"/"} className="navbar-brand">
        Welcome
      </Link>
      <div className="navbar-nav mr-auto">

        <li className="nav-item">
          <Link to={"/home"} className="nav-link">
            Home
          </Link>
        </li>              

        {currentUser && (
          <li className="nav-item">
            <Link to={"/frontpage"} className="nav-link">
              Dev
            </Link>
          </li>

        )}

      </div>

      {currentUser ? (
        <div className="navbar-nav ml-auto">
          <li className="nav-item">
            <Link to={"/profile"} className="nav-link">
              {currentUser.username}
            </Link>
          </li>
          <li className="nav-item">
            <a href="/login" className="nav-link" onClick={this.logOut}>
              LogOut
            </a>
          </li>
        </div>
      ) : (
        <div className="navbar-nav ml-auto">
          <li className="nav-item">
            <Link to={"/login"} className="nav-link">
              Login
            </Link>
          </li>

{/*           <li className="nav-item">
            <Link to={"/register"} className="nav-link">
              Sign Up
            </Link>
          </li> */}
        </div>
      )}
    </nav>
    )
  }

  parseJwt = (token) => {
    try {
      return JSON.parse(atob(token.split('.')[1]));
    } catch (e) {
      return null;
    }
  };

  render() {
    
    const { currentUser, showModeratorBoard, showAdminBoard } = this.state;

    //Expired token test
    //console.log('Hello App', this.props.user?.accessToken)
     if (this.props.user) {
        const token = this.props.user.accessToken
        //console.log(token)
        const decodedJwt = this.parseJwt(token);
        if (decodedJwt.exp * 1000 < Date.now()) this.logOut()
    }

    //console.log(    console.log('auth here....'),currentUser )
    const addMenuItems = [];
/*     if (showModeratorBoard) addMenuItems.push({ name: 'Moderator Board', path: '/mod', children: [] })
    if (showAdminBoard) addMenuItems.push({ name: 'Admin Board', path: '/admin', children: [] })
    if (currentUser) addMenuItems.push({ name: 'User', path: '/user', children: [] }) */
    if (currentUser) {
      addMenuItems.push({ name: 'Dev', path: '/frontpage', children: [] })
    }
      //console.log(addMenuItems)

//navbar-light bg-light   //navbar-dark bg-dark
    return ( //{ name: 'Link', path: '/link', children: [] },
      <Router history={history}>
        
        <div>
        {!currentUser ? this.navNotUserContent(): <DevNav addMenuItems = {addMenuItems} fncLogOut={this.logOut} />}

          <div className="container mt-3">
            <Switch>
              <Route exact path={["/", "/home"]} component={FrontPage} />
              <Route exact path="/login" component={Login} />
              <Route exact path="/register" component={Register} />
              <Route exact path="/profile" component={FrontPage} />
              <Route path="/user" component={BoardUser} />
              <Route path="/mod" component={BoardModerator} />
              <Route path="/admin" component={BoardAdmin} />
              <Route path="/frontpage" component={FrontPage} />
              <Route path="/stats" component={StatPageFrontpage} />
              <Route path="/device_list" component={PageAllDevices} />
              <Route path="/device_list_automat" component={PageAllDevices_automat} />
              <Route path="/selected_device/:dev_id" component={PageSelectedDevice} />
              <Route path="/selected_dev_mobile/:dev_id" component={PageSelectedDevMobile} />
              <Route path="/selected_devicex" component={PagexSensCollection} />
              <Route path="/sensors_collection/:collection_id" component={PageSensCollection} />
              <Route path="/projects" component={PageProjects} />
              <Route path="/selected_project/:project_id" component={SelectedProject} />
              <Route path="/selected_desk/:desk_id" component={PageSelectedDesk} />
              <Route path="/selected_desk_mobile/:desk_id" component={PageSelectedDeskMobile} />
              <Route path="/sp" component={ServicePage} />
              <Route path="/test" component={Test} />
            </Switch>
          </div>

          {/* <AuthVerify logOut={this.logOut}/> */}
        </div>
      </Router>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.auth;
  return {
    user,
  };
}

export default connect(mapStateToProps)(App);
